var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7333 1.34419C14.7333 0.32334 13.6503 -0.32194 12.769 0.173828L7.26262 3.27139C7.23455 3.28717 7.20298 3.29546 7.17088 3.29546H1.32222C0.591979 3.29546 0 3.89488 0 4.6343V9.9897C0 10.7291 0.591979 11.3285 1.32222 11.3285H1.54166L2.88142 16.3915C3.18833 17.5513 4.36567 18.2396 5.51108 17.9288C6.65649 17.618 7.33623 16.4259 7.02932 15.2661L6.55838 13.4864C6.47738 13.1803 6.16666 12.9987 5.86436 13.0807C5.56206 13.1627 5.38267 13.4773 5.46367 13.7834L5.9346 15.5631C6.07951 16.1107 5.75857 16.6736 5.21775 16.8203C4.67694 16.9671 4.12104 16.6421 3.97613 16.0945L2.71497 11.3285H4.76542L4.94034 11.9896C5.02134 12.2957 5.33207 12.4773 5.63436 12.3953C5.93666 12.3133 6.11606 11.9987 6.03506 11.6926L5.93873 11.3285H7.17088C7.20298 11.3285 7.23455 11.3368 7.26262 11.3526L12.769 14.4502C13.6503 14.9459 14.7333 14.3007 14.7333 13.2798V9.79247C16.0012 9.69481 17 8.62215 17 7.31329C17 6.00443 16.0012 4.93177 14.7333 4.8341V1.34419ZM14.7333 5.988V8.63858C15.3741 8.54577 15.8667 7.98778 15.8667 7.31329C15.8667 6.6388 15.3741 6.08081 14.7333 5.988ZM13.6 1.34419C13.6 1.19836 13.4453 1.10617 13.3194 1.177L7.81301 4.27456C7.61658 4.38505 7.39559 4.44304 7.17088 4.44304H1.32222C1.2179 4.44304 1.13333 4.52867 1.13333 4.6343V9.9897C1.13333 10.0953 1.2179 10.181 1.32222 10.181H7.17088C7.39559 10.181 7.61658 10.2389 7.81301 10.3494L10.9556 12.1173V3.87054C10.9556 3.55364 11.2093 3.29674 11.5222 3.29674C11.8352 3.29674 12.0889 3.55364 12.0889 3.87054V12.7548L13.3194 13.447C13.4453 13.5178 13.6 13.4256 13.6 13.2798V1.34419Z",
    fill: "#3F7CD6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarm);
export default __webpack_public_path__ + "static/media/icon_alarm.764beeefc00d234ae342293457dbca49.svg";
export { ForwardRef as ReactComponent };